import React, { useState } from 'react';
import { dispatchDoc } from '../services/api';
import './Destino.css';

const DESTINOS = [
  { id: 'drive', icon: '▲', label: 'Google Drive', sub: (emp) => `${emp} / documentos` },
  { id: 'email', icon: '✉', label: 'Email', sub: () => 'contabilidade@supernovacy.com' },
  { id: 'vps',   icon: '⬡', label: 'CacoVPS', sub: (emp) => `/apps/pombo/storage/${emp}/` },
];

export default function Destino({ reviewData, onSuccess, onBack }) {
  const { empresa, tipo, imagem } = reviewData || {};
  const [selected, setSelected] = useState(['vps']);
  const [sending, setSending] = useState(false);
  const [erro, setErro] = useState(null);

  const toggle = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]
    );
  };

  const handleSend = async () => {
    if (selected.length === 0) { setErro('Selecciona pelo menos um destino.'); return; }
    setSending(true);
    setErro(null);
    try {
      const formData = new FormData();
      formData.append('imagem', imagem);
      formData.append('empresa', empresa);
      formData.append('tipoDoc', tipo);
      formData.append('dados', JSON.stringify({
        tipo: reviewData.tipo,
        entidade: reviewData.entidade,
        data: reviewData.data,
        montante: reviewData.montante,
        nif: reviewData.nif
      }));
      formData.append('destinos', JSON.stringify(selected));
      const res = await dispatchDoc(formData);
      onSuccess(res.data);
    } catch (err) {
      setErro('Erro ao enviar. Verifica a ligação.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="destino-page">
      <div className="destino-body">
        <div className="destino-summary">
          <span className={`empresa-badge ${empresa?.toLowerCase()}`}>{empresa}</span>
          <span className="destino-summary-text">{tipo} · {reviewData?.entidade || '—'} · {reviewData?.montante || '—'}</span>
        </div>

        <p className="destino-instruction">Selecciona um ou mais destinos</p>

        <div className="destino-list">
          {DESTINOS.map(d => (
            <button
              key={d.id}
              className={`destino-item ${selected.includes(d.id) ? 'selected' : ''}`}
              onClick={() => toggle(d.id)}
            >
              <span className="destino-icon">{d.icon}</span>
              <div className="destino-text">
                <div className="destino-name">{d.label}</div>
                <div className="destino-sub">{d.sub(empresa)}</div>
              </div>
              <div className={`destino-check ${selected.includes(d.id) ? 'checked' : ''}`}>
                {selected.includes(d.id) && '✓'}
              </div>
            </button>
          ))}
        </div>

        {erro && <p className="destino-erro">{erro}</p>}
      </div>

      <div className="destino-footer">
        <button className="destino-back-btn" onClick={onBack} disabled={sending}>← Voltar</button>
        <button className="destino-send-btn" onClick={handleSend} disabled={sending || selected.length === 0}>
          {sending ? 'A enviar...' : `Enviar (${selected.length}) →`}
        </button>
      </div>
    </div>
  );
}
